import React, { FC, memo } from 'react';
import { Map, TileLayer } from 'react-leaflet';
import { createUseStyles } from 'src/theming';
import { LegacyCustomer } from 'src/interfaces/api/Customer';
import CustomerMarker from './components/CustomerMarker';
import MarkerClusterGroup from 'react-leaflet-markercluster';
import clsx from 'clsx';

const useStyles = createUseStyles((theme) => ({
  root: ({ height }) => ({
    height: height - theme.components.TopBar.height,
    borderRadius: 10,
  }),
}));

interface Props {
  className?: any;
  height: number;
  customers: LegacyCustomer[];
}

const CustomersMap: FC<Props> = ({ className, customers, height }) => {
  const classes = useStyles({ height });

  return (
    <Map className={clsx(className, classes.root)} center={[46, 2]} zoom={6}>
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url='https://tile.webf.fr/hot/{z}/{x}/{y}.png'
      />

      <MarkerClusterGroup>
        {customers.map((customer) => (
          <CustomerMarker customer={customer} key={customer.id} />
        ))}
      </MarkerClusterGroup>
    </Map>
  );
};

export default memo(CustomersMap, (prevProps, nextProps) => prevProps.customers === nextProps.customers);
